document.addEventListener('DOMContentLoaded', function () {
  var select = document.getElementById('ContactCategory');
  var sections = document.querySelectorAll('.bevel-contact__section');

  if (!select) return;

  function updateVisibleSection() {
    var selected = select.value;

    sections.forEach(function (section) {
      var isMatch = section.dataset.category === selected;
      section.hidden = !isMatch;

      var fields = section.querySelectorAll('input, select, textarea');
      fields.forEach(function (field) {
        field.disabled = !isMatch;
      });
    });
  }

  select.addEventListener('change', updateVisibleSection);
  updateVisibleSection();
});
